import { createThemeTypeThemesConfig, type ThemeTypeTheme } from '@/config/objects/theme-type-themes';
import { CrudListView } from '@startupquickstart/frontend';
import { useCallback, useMemo } from 'react';
import { useNavigate } from 'react-router-dom';

interface ThemeTypeThemesListProps {
  themeTypeId: string;
  className?: string;
}

/**
 * Theme type themes list component
 * Displays all attraction themes that use this theme type
 */
export function ThemeTypeThemesList({ themeTypeId, className }: ThemeTypeThemesListProps) {
  const navigate = useNavigate();

  const themesConfig = useMemo(
    () => createThemeTypeThemesConfig(themeTypeId),
    [themeTypeId],
  );

  const handleItemClick = useCallback(
    (theme: ThemeTypeTheme) => {
      if (theme.attractionId) {
        navigate(`/attractions/${theme.attractionId}/themes/${theme.id}`);
      }
    },
    [navigate],
  );

  return (
    <div className={className}>
      <CrudListView
        config={themesConfig}
        baseUrl=""
        onItemClick={handleItemClick}
        getValueFromItem={(theme: ThemeTypeTheme) => theme.id}
        getLabelFromItem={(theme: ThemeTypeTheme) =>
          theme.attraction?.name || 'Unnamed Theme'
        }
      />
    </div>
  );
}
